import { addContextUpdateListener, getContext } from '@dvag/dfs-orchestrator-client';
import { FeatureDefinition, GrowthBook } from '@growthbook/growthbook-react';

type FeatureFlag = {
  gb: GrowthBook<Record<string, unknown>>;
  init: () => void;
};

type OrchestratorFeatureFlags = Record<string, boolean> | undefined;

let isInitialized = false;

const mapFeatureFlags = (
  featureFlags: OrchestratorFeatureFlags,
): Record<string, FeatureDefinition<boolean>> =>
  Object.fromEntries(
    Object.entries(featureFlags ?? {}).map(([key, value]) => [key, { defaultValue: value }]),
  );

const featureFlag: FeatureFlag = {
  gb: new GrowthBook(),

  init: () => {
    if (isInitialized) {
      return;
    }

    const context = getContext();

    featureFlag.gb.setAttributes({
      advisorId: context.user?.advisor?.id,
    });

    featureFlag.gb.initSync({
      payload: {
        features: mapFeatureFlags(context.featureFlags),
      },
    });

    addContextUpdateListener((updatedContext) => {
      featureFlag.gb.setAttributes({
        advisorId: updatedContext.user?.advisor?.id,
      });

      featureFlag.gb.setPayload({
        features: mapFeatureFlags(updatedContext.featureFlags),
      });
    });

    isInitialized = true;
  },
};

export default featureFlag;
